import { Coupon, CouponProps } from '@/components/Coupon';
import { Breakpoint } from '@/components/GameBreakpoint';
import { CouponGroupConfig } from '@/config/game';
import { CouponGroupState } from '@/reducers/couponGroup';
import createArrayFromNumber from '@/utilities/createArrayFromNumber';
import React from 'react';

export interface CouponGroupProps extends CouponGroupConfig {
  crossedNumbers: CouponGroupState;
  onClickCoupon?: CouponProps['onClick'];
  onClickCouponNumber?: CouponProps['onClickCouponNumber'];
  onClear: CouponProps['onClear'];
  onClearAll: () => void;
  viewSize: Breakpoint;
  currentAmount: number;
}

export class CouponGroup extends React.Component<CouponGroupProps> {
  render(): JSX.Element {
    const lastFilledCoupon: number = Object.keys(
      this.props.crossedNumbers
    ).reduce((prev, couponId) => {
      const indexGroup = Object.keys(
        this.props.crossedNumbers[couponId]
      ).filter((groupId) => {
        return this.props.crossedNumbers[couponId][groupId].length > 0;
      });
      return indexGroup.length > 0 ? +couponId : prev;
    }, 0);

    const isDisabled = (couponId) => {
      return lastFilledCoupon < +couponId - 1;
    };

    const columns =
      this.props.columnsVariant && this.props.viewSize !== Breakpoint.Game
        ? this.props.columnsVariant
        : this.props.columns;

    return (
      <div className="CouponGroup">
        <div className="CouponGroup__coupons">
          {createArrayFromNumber(this.props.currentAmount).map((coupon) => {
            return (
              <Coupon
                key={coupon}
                index={coupon}
                ariaHidden={true}
                disabled={isDisabled(coupon)}
                showActionButtons={false}
                columns={columns}
                numberGroups={this.props.numberGroups}
                quickTipPerCoupon={this.props.quickTipPerCoupon}
                quickTips={this.props.quickTips}
                onClick={this.props.onClickCoupon}
                onClickCouponNumber={this.props.onClickCouponNumber}
                onClear={this.props.onClear}
                crossedNumbers={this.props.crossedNumbers[coupon]}
                viewSize={this.props.viewSize}
                layout={this.props.layout}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
